function _extends() {_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React, { useRef } from 'react';
import { connect } from 'react-redux';
import ReactModal from 'react-modal';
import { Tabs, TabLink, TabContent } from 'react-tabs-redux';
import Dropzone from 'react-dropzone';
import { bindActionCreators } from 'redux';
import { actions as formActions } from 'react-redux-form';
import { Translate } from "../../I18N";
import { Icon } from "../../UI";
import { WebMediaResourceForm } from "./WebMediaResourceForm";












const AttachmentsModalCmp = ({
  isOpen,
  entitySharedId,
  storeKey,
  model,
  onClose,
  uploadAttachment: uploadAttachmentProp,
  uploadAttachmentFromUrl: uploadAttachmentFromUrlProp,
  getPercentage
}) => {
  const inputFileRef = useRef(null);
  let formDispatch = () => {};

  const handleUploadButtonClicked = () => {
    if (inputFileRef.current) {
      inputFileRef.current.click();
    }
  };

  const handleInputFileChange = async (event) => {
    if (event.target.files) {
      await Promise.all(
        [...event.target.files].map((file) =>
        uploadAttachmentProp(entitySharedId, file, { __reducerKey: storeKey, model })
        )
      );
    }
  };

  const handleDropFiles = async (accepted) => {
    await Promise.all(
      accepted.map((file) =>
      uploadAttachmentProp(entitySharedId, file, { __reducerKey: storeKey, model })
      )
    );
  };

  const handleSubmitUrlForm = (formModelData) => {
    uploadAttachmentFromUrlProp(entitySharedId, formModelData, { __reducerKey: storeKey, model });
    formDispatch(formActions.reset('urlForm'));
  };

  return /*#__PURE__*/(
    _jsx(ReactModal, {
      isOpen: isOpen,
      className: "attachments-modal",
      overlayClassName: "attachments-modal__overlay",
      ariaHideApp: false }, void 0, /*#__PURE__*/

    _jsx("div", { className: "attachments-modal__header" }, void 0, /*#__PURE__*/
    _jsx("h4", {}, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Supporting files")
    ), /*#__PURE__*/

    _jsx("button", {
      type: "button",
      onClick: onClose,
      className: "attachments-modal__close",
      disabled: getPercentage !== undefined }, void 0, /*#__PURE__*/

    _jsx(Icon, { icon: "times" }), /*#__PURE__*/
    _jsx("span", {}, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Cancel")
    )
    )
    ), /*#__PURE__*/
    _jsx("div", { className: "attachments-modal__content" }, void 0, /*#__PURE__*/
    _jsx(Tabs, { renderActiveTabContentOnly: true }, void 0, /*#__PURE__*/
    _jsx("div", { className: "attachments-modal__tabs" }, void 0, /*#__PURE__*/
    _jsx(TabLink, { to: "uploadComputer", className: "tab-link modal-tab-1", component: "div" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Upload from computer")
    ), /*#__PURE__*/
    _jsx(TabLink, { to: "uploadWeb", className: "tab-link modal-tab-2", component: "div" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Add from web")
    )
    ), /*#__PURE__*/

    _jsx("div", { className: "attachments-modal__tabs-content" }, void 0, /*#__PURE__*/
    _jsx(TabContent, { for: "uploadComputer", className: "tab-content centered" }, void 0, /*#__PURE__*/
    _jsx(Dropzone, { noClick: true, onDrop: handleDropFiles, multiple: false }, void 0,
    ({ getRootProps }) => /*#__PURE__*/
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement("div", _extends({}, getRootProps(), { className: "attachments-modal__dropzone" }),
    getPercentage === undefined ? /*#__PURE__*/
    React.createElement(React.Fragment, null, /*#__PURE__*/
    _jsx("button", { type: "button", onClick: handleUploadButtonClicked, className: "btn" }, void 0, /*#__PURE__*/
    _jsx(Icon, { icon: "link" }), "\xA0 ", /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Upload and select file")
    ), /*#__PURE__*/
    React.createElement("input", {
      "aria-label": "fileInput",
      type: "file",
      onChange: handleInputFileChange,
      style: { display: 'none' },
      ref: inputFileRef }
    ), /*#__PURE__*/
    _jsx("h4", { className: "attachments-modal__dropzone-title" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Drag and drop file in this window to upload")
    )
    ) : /*#__PURE__*/

    _jsx("div", { className: "progress attachments-modal-progress" }, void 0, /*#__PURE__*/
    _jsx("div", {
      className: "progress-bar progress-bar-success attachments-modal-progress-bar",
      role: "progressbar",
      style: { width: `${getPercentage}%` } }
    )
    )

    )

    )
    ), /*#__PURE__*/
    _jsx(TabContent, { for: "uploadWeb", className: "tab-content centered" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "wrapper-web" }, void 0, /*#__PURE__*/
    _jsx(WebMediaResourceForm, {
      handleSubmit: handleSubmitUrlForm,
      dispatch: (dispatch) => {
        formDispatch = dispatch;
      },
      hasName: true }
    )
    )
    )
    )
    )
    )
    ));

};

const mapDispatchToProps = (dispatch, ownProps) =>
bindActionCreators(
  {
    uploadAttachment: ownProps.uploadAttachment,
    uploadAttachmentFromUrl: ownProps.uploadAttachmentFromUrl
  },
  dispatch
);

const AttachmentsModal = connect(null, mapDispatchToProps)(AttachmentsModalCmp);


export { AttachmentsModalCmp, AttachmentsModal };